import React from 'react';
import { Chip } from '@mui/material';

/**
 * StatusChip — one place that maps a semantic status string to a chip colour.
 *
 * Callers pass a `statusMap` for their domain rather than each page inventing its
 * own colour logic. Unknown statuses degrade to a neutral chip instead of throwing
 * or rendering nothing.
 */
const humanize = (value) => (value || 'unknown').toString().replace(/_/g, ' ');

const StatusChip = ({
    status,
    statusMap = {},
    label,
    size = 'small',
    variant = 'filled',
    sx = {},
    ...props
}) => {
    const key = (status || '').toString().toLowerCase();
    const color = statusMap[key] || 'default';

    return (
        <Chip
            size={size}
            variant={variant}
            color={color}
            label={label ?? humanize(status)}
            sx={{ textTransform: 'capitalize', ...sx }}
            {...props}
        />
    );
};

export default StatusChip;
